import TimebombManager from './timebomb-manager';

export default TimebombManager;
